import {toast} from 'react-hot-toast'
import {localise} from '../../services/LocalizationServices'

export default err => {
  toast.error(err?.message || localise('toast.genericError'))
  return Promise.reject(err)
}
